import { render, staticRenderFns } from "./AppCardFooter.vue?vue&type=template&id=47e87c98&"
import script from "./AppCardFooter.vue?vue&type=script&lang=js&"
export * from "./AppCardFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports